/**
 * @description
 * @author Kody
 * @date 2018-07-03
 */

import Api from '../../../../path';
import { fetchData } from '@umu/umu-fetch';
import IInput from './models/input';
import IOutput from './models/output';

export const getElementStat = (data: IInput): Promise<IResponse<IOutput>> => {
    return fetchData(Api.GET_ELEMENT_STAT, data).then((res: IResponse<IOutput>) => {
        return res.data;
    });
};
